<template>
  <div id="app" @contextmenu.prevent>
    <NavBar v-show="showNavBarTop" />
    <div class="content-wrapper" :class="{'content-wrapper--full-screen': !showNavBar}">
      <transition name="slide-fade" mode="out-in" appear>
        <router-view/>
      </transition>
    </div>
    <div v-show="showNavBar" class="footer">
      Ⓒ 2019 Aibee all rights reserved
    </div>
    <transition name="fade" mode="out-in" appear>
      <div v-if="loading" class="mng-loading-indicator">
        <scaling-squares-spinner
          :animation-duration="1000"
          :size="40"
          :color="'#424242'" />
      </div>
    </transition>
  </div>
</template>

<script>
import { ScalingSquaresSpinner } from 'epic-spinners';
import { mapGetters } from 'vuex';

import NavBar from '@/components/nav-bar.vue';

export default {
  name: 'App',
  components: {
    NavBar,
    ScalingSquaresSpinner
  },
  computed: {
    showNavBarTop(){
       return (/^\/x/g).test(this.$route.path);
    },
    showNavBar() {

      if(this.$route.path.indexOf('/x/mapAlignments/')!=-1) return false;
      return (/^\/x/g).test(this.$route.path);
    },
    ...mapGetters({
      loading: 'loading'
    })
  },
  methods: {}
};
</script>

<style lang="scss">
#app {
  position: relative;
  height: 100vh;
  width: 100vw;
  overflow-x: auto;
  overflow-y: hidden;
}

.slide-fade-enter-active {
  transition: all .15s ease;
}

.slide-fade-leave-active {
  transition: all .15s cubic-bezier(1, .5, .8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
